import { LoadingDatesTO } from '../../../store/edit-relocation-detail/relocation-detail.interface';

const response: LoadingDatesTO = {
  fromDates: ['2019-03-12', '2019-03-13', '2019-03-14', '2019-03-16'],
  toDates: ['2019-03-12', '2019-03-13', '2019-03-14', '2019-03-17'],
};

export default response;
